export default __webpack_public_path__ + "static/media/tab-03.af0c5335.svg";